const loginBtns = document.querySelectorAll(".btn-loader");

    loginBtns.forEach(loginBtn => {
      loginBtn.addEventListener('click', () => {
        loginBtn.classList.add("loading");
    
        setTimeout(() => loginBtn.classList.remove("loading"), 3000);
      });
    });